<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  name: "app",

  methods: {
  

    
  },

  mounted() {
   
  }
};
</script>

<style>
#app {
  font-family: "PingFangSC-Light", "Microsoft Yahei", Arial, Helvetica,
    sans-serif;
  color: #383838;
  font-size: 14px;
}
.clear {
  clear: both;
}
</style>
